var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/action/delete_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/delete_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6665 3H9.6665L8.6665 4H5.1665V6H19.1665V4H15.6665L14.6665 3ZM16.1665 9V19H8.1665V9H16.1665ZM6.1665 7H18.1665V19C18.1665 20.1 17.2665 21 16.1665 21H8.1665C7.0665 21 6.1665 20.1 6.1665 19V7Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 15,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/delete_24px_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6665 3H9.6665L8.6665 4H5.1665V6H19.1665V4H15.6665L14.6665 3ZM16.1665 9V19H8.1665V9H16.1665ZM6.1665 7H18.1665V19C18.1665 20.1 17.2665 21 16.1665 21H8.1665C7.0665 21 6.1665 20.1 6.1665 19V7Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.cc5f8d4a6f62d779d12d9174b6c132ff.svg";
export { ForwardRef as ReactComponent };